import { graphql } from 'react-relay';

export const getHomeContentQuery = graphql`
  query homeContentQuery {
    getRefundUserMarketingTerm {
      terms {
        termKey
        isApproved
      }
    }
    bznavRefund {
      user {
        indis {
          refundStatus
          snmcSpcTxreAmt
          cenSnmcTxreAmt
          empIncrEtrpTxamtDdcAmt
          intgEmpTxamtDdcAmt
          sctyInfeeTxamtDdcAmt
          reSearchRequestId
        }
        corps {
          refundStatus
        }
        previousIndis {
          refundStatus
        }
        tritxIndis {
          id
          refundId
          refundAmount
          refundStatus
          tritxReSearchRequestId
          businessInfo {
            taxpayerName
          }
          refundStage
          cancelStage
        }
      }
    }
    ...RetryBanner
    ...IndisSection
    ...CorpsSection
  }
`;
